import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '../../environments/environment';
import { HomeindexComponent } from '../homeindex/homeindex.component';
import { LoginComponent } from '../login/login.component';
import { SingnUpComponent } from '../singn-up/singn-up.component';
import { RestLoginComponent } from '../rest-login/rest-login.component';
import { ConditionUtilisationComponent } from '../condition-utilisation/condition-utilisation.component';
import { PConfidentialityComponent } from '../p-confidentiality/p-confidentiality.component';
import { OnlinegetwayComponent } from '../onlinegetway/OnlinegetwayComponent';
import { DevDeployDocsComponent } from './dev-deploy-docs/dev-deploy-docs.component';

const routes: Routes = [
  { path: '', redirectTo: 'spay', pathMatch: 'full' },
  { path: 'spay', component: HomeindexComponent },
  { path: 'connection', component: LoginComponent },
  { path: 'signup', component: SingnUpComponent },
  { path: 'utilisateur/reset/password', component: RestLoginComponent },
  { path: 'conditions-utilisation', component: ConditionUtilisationComponent },
  { path: 'politique-de-confidentialite', component: PConfidentialityComponent },
  { path: 'online/gate/way/payment', component: OnlinegetwayComponent },
  ...(environment.production
    ? []
    : [{ path: 'dev/docs/deploiement', component: DevDeployDocsComponent }]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicRoutingModule { }
